import { FC, Children, useState } from 'react';
import { Icon } from '../components/Editor/components';

interface iHeaderProps {
  label: string;
  onNext: () => void;
  onPrev: () => void;
  last: boolean;
  first: boolean;
}
const Header: FC<iHeaderProps> = ({ label, onPrev, onNext, last, first }) => {
  return (
    <header className='sidebar-header'>
      <button onClick={onPrev} className={first ? 'hidden' : ''}>
        <Icon>ArrowLeft</Icon>
      </button>
      <span className='label'>{label}</span>
      <button onClick={onNext}>
        <Icon>{last ? 'Finish' : 'Next'}</Icon>
      </button>
    </header>
  );
};
const Iterator: FC = ({ children }) => {
  const [step, setStep] = useState(0);
  const arrayChildren = Children.toArray(children);

  const _handleDirection = (dir: number) => () => setStep(Math.max(0, Math.min(arrayChildren.length - 1, step + dir)));
  if (window.innerWidth > 500) return <>{children}</>;
  return (
    <>
      <Header
        first={step === 0}
        last={step === arrayChildren.length - 1}
        label={(arrayChildren[step] as any)?.props?.label?.split(' ')?.reverse()?.[0]}
        onNext={_handleDirection(1)}
        onPrev={_handleDirection(-1)}
      />
      {Children.map(arrayChildren, (child, index) => {
        if (step !== index) return null;
        return child;
      })}
    </>
  );
};

export default Iterator;
